import Layout from "../Layout";

export default [
  {
    path: "/contact",
    name: "contactpagelayout",
    component: Layout,
  }
];
